/**
 * Mounts all modals for the Quick Review board page.
 *
 * Centralizes the `openedModalId` to modal mapping so the page stays a pure
 * layout shell; register future Quick Review modals here.
 * @module quickReviewModals
 */
import QuickReviewModal from "../../../../../components/modals/quickReviewModal/quickReviewModal";
import { ModalId } from "../../../../../enums/modalId";
import { closeModal } from "../../../../../redux/slice/modalSlice";
import { useQuickReviewModals } from "../../hooks/useQuickReviewModals";

/**
 * Conditionally mounts Quick Review modals based on redux `openedModalId`.
 *
 * @returns Fragment of active Quick Review modal components
 */
const QuickReviewModals = () => {
  const { dispatch, openedModalId } = useQuickReviewModals();

  return (
    <>
      {openedModalId === ModalId.QUICK_REVIEW_MODAL && (
        <QuickReviewModal onClose={() => dispatch(closeModal())} />
      )}
      {/* Register additional Quick Review modals here. */}
    </>
  );
};

export default QuickReviewModals;
